import React, { useState } from 'react'
import { Progress } from 'antd'
import { format } from 'date-fns'
import {
  MiddleSection,
  TabSelector,
  StyledSegmented,
  MetricsSection,
  MetricsRow,
  MetricsColumn,
  MetricButton,
  Text,
  MetricValue,
  PainScaleBox,
  PainScaleText,
  PainScaleLabels,
  SymptomsSection,
  SymptomsCard,
  SummaryNote,
  DateInputRow,
  DateInfo,
  AppointmentsList,
  AppointmentRow,
  AppointmentInfo,
  AppointmentTimeContainer,
  ScanTag,
  HeaderLeftGroup,
  AtdBox,
  MembershipExpiryDate,
  Circle,
  DayTag,
  DayTagLeft,
  DayTagRight,
  DayTagCircleGroup,
} from './index.styled'
import { useAssessment } from './useAssessment'
import CircleTickImg from '../../../../images/circleTick.png'
import { APIStatus } from '../../../../redux/types'
import ShopItemsCard from '../../../../tabs/current/ShopItemsCard'
import { isMember } from '../../../../utils/isMember'

export default function AssessmentPanel({}) {
  const {
    tabValue,
    // setTabValue,
    currentPatient,
    selectedQuestions,
    currentVisit,
    currentWeekNumber,
    painScaleConfig,
    shouldFlashSingleWeek,
    shouldFlashAllWeeks,
    dslHighlight,
    ltdHighlight,
    metricsFlash,
    ltdDisplay,
    isToggleDisabled,
    subscriptionProgress,
    visitFrequencyDisplay,
    handleCycleDayTagLevel,
    updateVisitFrequencyStatus,
    nextAppointmentDay,
    nextAppointmentDayStatus,
  } = useAssessment()
  return (
    <MiddleSection>
      {currentVisit && currentPatient && (
        <>
          <TabSelector>
            <HeaderLeftGroup>
              <AtdBox>
                <Text $bold>{currentPatient?.metrics?.atd ?? '-'}</Text>
              </AtdBox>
              {isMember(currentPatient?.userPaymentPlan?.subscriptionExpiresAt || null) && (
                <MembershipExpiryDate>
                  <Text $bold>
                    {currentPatient?.userPaymentPlan?.subscriptionExpiresAt
                      ? format(new Date(currentPatient.userPaymentPlan.subscriptionExpiresAt), 'EEEE')
                      : ''}
                  </Text>
                  <Text $bold>
                    {currentPatient?.userPaymentPlan?.subscriptionExpiresAt
                      ? format(new Date(currentPatient.userPaymentPlan.subscriptionExpiresAt), 'MMM d')
                      : ''}
                  </Text>
                </MembershipExpiryDate>
              )}
            </HeaderLeftGroup>
            {/* <StyledSegmented
              options={[
                { label: <div>S</div>, value: 'S', disabled: isToggleDisabled },
                { label: <div>W</div>, value: 'W' },
              ]}
              value={tabValue}
              // onChange={(value) => setTabValue(value as 'S' | 'W')}
              $disabled={
                currentPatient?.treatmentTracker?.data?.type === 'single' || !currentPatient?.treatmentTracker?.data
              }
              disabled={
                currentPatient?.treatmentTracker?.data?.type === 'single' || !currentPatient?.treatmentTracker?.data
              }
            /> */}
            <DayTagCircleGroup>
              {currentPatient &&
                isMember(currentPatient?.userPaymentPlan?.subscriptionExpiresAt || null) &&
                currentPatient?.userPaymentPlan?.subscriptionExpiresAt && (
                  <DayTag>
                    <DayTagLeft
                      onClick={handleCycleDayTagLevel}
                      $disabled={
                        updateVisitFrequencyStatus === APIStatus.pending ||
                        nextAppointmentDayStatus === APIStatus.pending
                      }
                    >
                      {visitFrequencyDisplay}
                    </DayTagLeft>
                    <DayTagRight>{nextAppointmentDay || ''}</DayTagRight>
                  </DayTag>
                )}
              {currentPatient &&
                isMember(currentPatient?.userPaymentPlan?.subscriptionExpiresAt || null) &&
                currentPatient?.treatmentTracker?.data?.isNewMember &&
                currentPatient?.treatmentTracker?.data?.freeMonthEligible === true &&
                subscriptionProgress.showProgress && (
                  <Progress
                    type="circle"
                    size={33.8}
                    strokeColor="#007f7c"
                    trailColor="#D9D5D2"
                    percent={subscriptionProgress.progressPercent}
                    format={(percent) => (
                      <span style={{ color: '#000000', fontWeight: 700, fontSize: '14px' }}>
                        {subscriptionProgress.displayNumber != null ? subscriptionProgress.displayNumber : '-'}
                      </span>
                    )}
                  />
                )}
              {currentPatient &&
                isMember(currentPatient?.userPaymentPlan?.subscriptionExpiresAt || null) &&
                currentPatient?.treatmentTracker?.data?.isNewMember &&
                currentPatient?.treatmentTracker?.data?.freeMonthEligible === true &&
                subscriptionProgress.showCircle && (
                  <img src={CircleTickImg} style={{ width: '33.8px', height: '33.8px' }} alt="tick" />
                )}
            </DayTagCircleGroup>
          </TabSelector>

          {/* --- Metrics Section --- */}

          {currentPatient?.treatmentTracker?.data?.type === 'symptomatic' && tabValue === 'S' && (
            <MetricsSection>
              <MetricsRow>
                <MetricsColumn>
                  <MetricButton $highlight={dslHighlight} $flash={metricsFlash}>
                    <Text $bold $marginBottom={-8} $marginTop={-2}>
                      DSL
                    </Text>
                    <MetricValue>{currentPatient?.metrics?.dst ?? '-'}</MetricValue>
                  </MetricButton>

                  <MetricButton $highlight={ltdHighlight} $flash={metricsFlash}>
                    <Text $bold $marginBottom={-8} $marginTop={-2}>
                      LTD
                    </Text>
                    <MetricValue>{ltdDisplay}</MetricValue>
                  </MetricButton>
                </MetricsColumn>

                {painScaleConfig.boxes.map((box) => {
                  const shouldAnimate =
                    shouldFlashAllWeeks && currentWeekNumber
                      ? box.weekNumber <= currentWeekNumber
                      : shouldFlashSingleWeek && currentWeekNumber
                        ? box.weekNumber === currentWeekNumber
                        : false

                  return (
                    <PainScaleBox key={box.weekNumber} $animation={shouldAnimate} $bg={box.bg} $disabled={box.disabled}>
                      <PainScaleText>{box.label || box.weekNumber}</PainScaleText>
                    </PainScaleBox>
                  )
                })}
              </MetricsRow>

              {/* <PainScaleLabels>
                    <Text
                      $bold
                      $color={
                        painScaleConfig.symptomaticEnabled ? 'var(--color-text-primary)' : 'var(--color-disabled)'
                      }
                    >
                      Symptomatic
                    </Text>
                    <Text
                      $bold
                      $color={painScaleConfig.correctiveEnabled ? 'var(--color-text-primary)' : 'var(--color-disabled)'}
                    >
                      Corrective
                    </Text>
                  </PainScaleLabels> */}
            </MetricsSection>
          )}
          {/* {currentPatient?.treatmentTracker?.data?.type === 'preventative' && tabValue === 'W' && (
            <MetricsSection>
              <MetricsRow>
                <MetricsColumn>
                  <MetricButton $highlight={dslHighlight} $flash={metricsFlash}>
                    <Text $bold $marginBottom={-8} $marginTop={-2}>
                      DSL
                    </Text>
                    <MetricValue>{currentPatient?.metrics?.dst ?? '-'}</MetricValue>
                  </MetricButton>

                  <MetricButton $highlight={ltdHighlight} $flash={metricsFlash}>
                    <Text $bold $marginBottom={-8} $marginTop={-2}>
                      LTD
                    </Text>
                    <MetricValue>{ltdDisplay}</MetricValue>
                  </MetricButton>
                </MetricsColumn>

                {painScaleConfig.boxes.map((box) => {
                  // const shouldAnimate =
                  //   shouldFlashAllWeeks && currentWeekNumber
                  //     ? box.weekNumber <= currentWeekNumber
                  //     : shouldFlashSingleWeek && currentWeekNumber
                  //       ? box.weekNumber === currentWeekNumber
                  //       : false

                  return (
                    <PainScaleBox key={box.weekNumber} $animation={false} $bg={box.bg} $disabled={box.disabled}>
                      <PainScaleText>{box.label || box.weekNumber}</PainScaleText>
                    </PainScaleBox>
                  )
                })}
              </MetricsRow>
            </MetricsSection>
          )} */}
          {currentPatient?.treatmentTracker?.data?.type === 'single' && (
            // ------------------- DISABLED VERSION (W) -------------------
            <MetricsSection>
              <MetricsRow>
                <MetricsColumn>
                  <MetricButton $highlight={dslHighlight} $flash={metricsFlash}>
                    <Text $bold $marginBottom={-8} $marginTop={-2}>
                      DSL
                    </Text>
                    <MetricValue>{currentPatient?.metrics?.dst ?? '-'}</MetricValue>
                  </MetricButton>

                  <MetricButton $highlight={ltdHighlight} $flash={metricsFlash}>
                    <Text $bold $marginBottom={-8} $marginTop={-2}>
                      LTD
                    </Text>
                    <MetricValue>{ltdDisplay}</MetricValue>
                  </MetricButton>
                </MetricsColumn>

                {painScaleConfig.boxes.map((box) => (
                  <PainScaleBox
                    key={box.weekNumber}
                    $bg="var(--color-disabled-bg)"
                    $border="var(--color-disabled)"
                    $textColor="var(--color-disabled)"
                  >
                    <PainScaleText>{box.weekNumber}</PainScaleText>
                  </PainScaleBox>
                ))}
              </MetricsRow>

              {/* <PainScaleLabels>
                <Text $color="var(--color-disabled)" $bold>
                  Symptomatic
                </Text>
                <Text $color="var(--color-disabled)" $bold>
                  Corrective
                </Text>
              </PainScaleLabels> */}
            </MetricsSection>
          )}
          {!currentPatient?.treatmentTracker?.data && (
            // ------------------- DISABLED VERSION (W) -------------------
            <MetricsSection>
              <MetricsRow>
                <MetricsColumn>
                  <MetricButton $highlight={dslHighlight} $flash={metricsFlash}>
                    <Text $bold $marginBottom={-8} $marginTop={-2}>
                      DSL
                    </Text>
                    <MetricValue>{currentPatient?.metrics?.dst ?? '-'}</MetricValue>
                  </MetricButton>

                  <MetricButton $highlight={ltdHighlight} $flash={metricsFlash}>
                    <Text $bold $marginBottom={-8} $marginTop={-2}>
                      LTD
                    </Text>
                    <MetricValue>{ltdDisplay}</MetricValue>
                  </MetricButton>
                </MetricsColumn>

                {painScaleConfig.boxes.map((box) => (
                  <PainScaleBox
                    key={box.weekNumber}
                    $bg="var(--color-disabled-bg)"
                    $border="var(--color-disabled)"
                    $textColor="var(--color-disabled)"
                  >
                    <PainScaleText>{box.weekNumber}</PainScaleText>
                  </PainScaleBox>
                ))}
              </MetricsRow>

              {/* <PainScaleLabels>
                <Text $color="var(--color-disabled)" $bold>
                  Symptomatic
                </Text>
                <Text $color="var(--color-disabled)" $bold>
                  Corrective
                </Text>
              </PainScaleLabels> */}
            </MetricsSection>
          )}

          {/* --- Symptoms Section --- */}

          {selectedQuestions.length > 0 && (
            <SymptomsSection>
              {selectedQuestions.map((label: string) => (
                <SymptomsCard key={label}>
                  <Text $bold>{label}</Text>
                </SymptomsCard>
              ))}
            </SymptomsSection>
          )}

          {/* --- Notes --- */}
          {currentPatient?.patient?.notes && <SummaryNote>{currentPatient?.patient?.notes ?? ''}</SummaryNote>}

          <ShopItemsCard visitId={currentVisit?.visitId} />

          {/* --- Appointment Row --- */}
          {currentPatient?.upcomingVisits && currentPatient.upcomingVisits.length > 0 && (
            <AppointmentsList>
              {currentPatient.upcomingVisits.slice(0, 2).map((visit) => {
                const appointmentDate = new Date(visit.appointmentTime)
                return (
                  <AppointmentRow key={visit.id}>
                    <AppointmentInfo>
                      <Text $bold>{format(appointmentDate, 'EEEE, MMM d')}</Text>
                      <Text>{visit.clinic.name}</Text>
                    </AppointmentInfo>

                    <AppointmentTimeContainer>
                      {visit.isScanBooking && (
                        <ScanTag>
                          <Text>SCAN</Text>
                        </ScanTag>
                      )}
                      <Text $size={24} style={{ marginTop: visit.isScanBooking ? 0 : 23 }}>
                        {format(appointmentDate, 'h:mm a')}
                      </Text>
                    </AppointmentTimeContainer>
                  </AppointmentRow>
                )
              })}
            </AppointmentsList>
          )}
        </>
      )}
    </MiddleSection>
  )
}
